import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { comentariosOportunidad } from "../../modelos/comentariosOportunidad.model";
import { OperativoService } from "../../opeartivo.service";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { Base } from "src/app/shared/model/core/base.model";


// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas
import { MatListModule } from '@angular/material/list'; // FIX: para mat-selection-list / mat-list-option

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular
import { MatRadioButton } from "@angular/material/radio";

@Component({
    selector: "app-modal-agregar-comentario",
    standalone: true,
    templateUrl: "./modal-agregar-comentario.component.html",
    styleUrls: ["./modal-agregar-comentario.component.css"],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgxMatSelectSearchModule,
      MatListModule // FIX
    ]
})
export class ModalAgregarComentarioComponent {
  formRegistro: FormGroup;
  totalsize = 0;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  comentariodata: comentariosOportunidad = new comentariosOportunidad();
  constructor(
    public dialogRef: MatDialogRef<ModalAgregarComentarioComponent>,
    readonly formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    readonly service: OperativoService,
    readonly msg: Msg,
  ) {}

  ngOnInit() {
    if (this.data) {
      this.comentariodata.idGit = this.data.idGit;
      this.comentariodata.estado = this.data.estado;
    }
    this.formreg();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  subirEv() {
    const input = <HTMLInputElement>document.getElementById("nameFile");
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  elimina() {
    for (let archivo of this.selectedOptions) {
      this.index = this.evidencia.findIndex(
        (item) => item.name == archivo.name
      );
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  onNgModelChange($event) {
    this.selectedOptions = $event;
    if (this.selectedOptions.length != 0) {
      this.btnElimina = false;
      this.btnAgrega = true;
    } else {
      this.btnElimina = true;
      this.btnAgrega = false;
    }
  }

  onSave(): void {
    if (this.formRegistro.valid) {
      this.comentariodata.contenido = this.formRegistro.value.comentario;
      if(this.evidencia.length>0){
        this.service.guardarComentarioOportunidadArchivo(this.getRequestForm()).subscribe((response: any) => {
          if (response?.status && response.status === "ok") {
            let resCargarArchivo: Base = response.body;
            this.validarRespuestaGuardado(resCargarArchivo);
          }
        });
      }
      else{
        this.comentariodata.archivosComentarios =[];
        this.service.guardarComentarioOportunidad(this.comentariodata).subscribe((response: any) => {
          this.validarRespuestaGuardado(response);
          
        });
      }
    }
  }

  validarRespuestaGuardado(response: any){
    if (response.pCodRetorno === "00000") {
      this.msg.showSuccessNotification("top","Comentario guardado exitosamente.");
      this.dialogRef.close(response);
    }else{
      this.msg.showErrorNotification("top","Ocurrió un problema al  guardar el comentario.");
      this.dialogRef.close(response);
    }
  }

 getRequestForm(): FormData {
  const formData = new FormData();
  let comentario = new Blob([ JSON.stringify(this.comentariodata)], {type:'application/json'});
  formData.append("comentario", comentario);
  
  this.evidencia.forEach((archivo) => {
    formData.append(
      "file",
      archivo,
      archivo.name
    );
  });
  return formData;
}
  formreg() {
    this.formRegistro = this.formBuilder.group({
      comentario: ["", [Validators.required]],
    });
  }
}
